import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { redirectToNotFoundPageIf404, RouteActions } from 'core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { API01V2RequestService } from '../API01V2-request.service';

@Injectable()
export class NeedOpenAPI01V2RouteGuard implements CanActivate {
    constructor(private routeActions: RouteActions, private requestService: API01V2RequestService) {}

    public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const idParamName = 'id';
        const paramMap = route.children[0].paramMap;
        if (paramMap.keys.length !== 1 || !paramMap.has(idParamName)) {
            return true;
        }
        const correlationId = paramMap.get(idParamName);
        if (correlationId) {
            return this.requestService.getBPCodeOfRequest(correlationId).pipe(
                redirectToNotFoundPageIf404(this.routeActions),
                map(bpCode => bpCode === 'API01V2'),
                tap(needOpenAPI01V2 => {
                    if (!needOpenAPI01V2) {
                        const api01Url = `api01m/${correlationId}`;
                        this.routeActions.navigate([api01Url]);
                    }
                })
            );
        }
        return true;
    }
}
